module.exports = __webpack_public_path__ + "img/FGr_Beleuchtung_A.85796275.svg";